import { Component, OnInit } from '@angular/core';
import { WorkflowPageNavigationService } from '../service/workflow-page-navigation/workflow-page-navigation.service';
import { WorkflowService } from '../service/workflow/workflow.service';
import { PageInstance } from '@workflow/class/page.service';
import { FlowInstance } from '@workflow/class/flow.service';

@Component({
  selector: 'cu-route-page',
  templateUrl: './route-page.component.html'
})
export class RoutePageComponent implements OnInit {
  public flow: FlowInstance;
  public page: PageInstance;

  constructor(private readonly workflowNavigation: WorkflowPageNavigationService, private readonly workflowService: WorkflowService) {
    // workflowService.setCurrentFlowAndPagePath(activatedRoute.snapshot.data.wf, activatedRoute.snapshot.data.page);
    this.workflowNavigation.pageNavigation$.subscribe((e) => this.updateCurrent(e.flow, e.page));
  }

  ngOnInit() {
    this.flow = this.workflowService.currentFlow;
    this.page = this.workflowService.currentPage;
  }

  private updateCurrent(flow: FlowInstance, page: PageInstance): void {
    this.flow = flow;
    this.page = page;
  }
}
